import React, { useState, useEffect } from "react";
import Heading from "./Heading";
import Button from "./Button";


const ContactForm = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobtitle: "",
    company: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [successMessage]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.jobtitle.trim()) newErrors.jobtitle = "Job title is required";
    if (!formData.company.trim()) newErrors.company = "Company is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Remove error when user types
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setTouched((prevTouched) => ({ ...prevTouched, [name]: true }));
  };

  const handleChange2 = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });

    // Remove error when user selects a value
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    setTouched((prevTouched) => ({ ...prevTouched, [field]: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Mark all fields as touched
    setTouched({
      name: true,
      email: true,
      phone: true,
      jobtitle: true,
      company: true,
      message: true,
    });

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(
        "https://blue.happyplus.in/api/v1/emprole/saveLawFirmContactUs",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSuccessMessage("Your message has been sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          jobtitle: "",
          company: "",
          message: "",
        });
        setErrors({});
        setTouched({});
      }
    } catch (error) {
      console.error("Error submitting form", error);
    }
    setIsSubmitting(false);
  };


  return (

    <section className="bg-cover bg-no-repeat md:py-16 py-8 bgwhite">
      <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="flex flex-col">

            <Heading className="textblack" text="Get In Touch?" />
            <p className="md:text-lg text-base font-semibold textblack my-7">Want To Get In Touch? We'd Love To Hear From You. Here's How You Can Reach Us.</p>

            <div className="space-y-6">
              <div className="bg-[#9B26350F] p-6 flex gap-4">
                <div className="textactive text-2xl">
                  <img src="/img/assets/home/office.svg" alt="Location Icon" className="w-14 h-14" />
                </div>
                <div>
                  <h2 className="font-semibold md:text-xl text-lg mb-2">Office Location</h2>
                  <p className="text-gray-700 text-sm leading-relaxed">GregandAllen Pvt. Ltd. Express Zone, Western Express Highway, Malad East, Mumbai – 400097</p>
                </div>
              </div>

              {/* Phone */}
              <div className="bg-[#9B26350F] p-6 flex gap-4">
                <div className="textactive">
                  <img src="/img/assets/home/phone.svg" alt="Phone Icon" className="w-10 h-10" />
                </div>
                <div>
                  <h2 className="font-semibold md:text-xl text-lg mb-2">Phone</h2>
                  <p className="text-gray-700 text-sm">+91 702-128-9308</p>
                </div>
              </div>

              {/* Email */}
              <div className="bg-[#9B26350F] p-6 flex gap-4">
                <div className="textactive">
                  <img src="/img/assets/home/email.svg" alt="Email Icon" className="w-10 h-10" />
                </div>
                <div>
                  <h2 className="font-semibold md:text-xl text-lg mb-2">Email</h2>
                  <p className="text-gray-700 text-sm">ceo@gregandallen.com</p>
                </div>
              </div>
   
            </div>
          </div>

          <div className="">
            <h1 className="text-3xl font-bold taextblack mb-8">Drop your queries here</h1>
            <p className="pb-8 textblack text-lg font-semibold">Fill out the form below, and we'll get back to you shortly.</p>

            <form onSubmit={handleSubmit} className="gap-4 grid grid-cols-1 md:grid-cols-2">
              {[
                { name: "name", label: "Full Name", type: "text", placeholder: "Full Name" },
                { name: "email", label: "Email", type: "email", placeholder: "Email" },
                { name: "phone", label: "Phone Number", type: "text", placeholder: "Phone" },
                { name: "company", label: "Company/Organization", type: "text", placeholder: "Company" },
              ].map(({ name, label, type, placeholder }) => (
                <div key={name}>
                  <label className="mb-1 font-medium taextblack before:text-[#F14678] text-base before:content-['*']">
                    {label}
                  </label>
                  <input
                    className="p-3 border border-[#212121] rounded focus:outline-none focus:ring-[#212121] focus:ring-1 w-full taextblack"
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={formData[name]}
                    onChange={handleChange}
                  />
                  {errors[name] && touched[name] && (
                    <p className="pt-2 text-red-600 text-xs invalid-feedback">{errors[name]}</p>
                  )}
                </div>
              ))}

              <div className="md:col-span-2">
                <label className="mb-1 font-medium taextblack before:text-[#F14678] text-base before:content-['*']">
                  Job Title
                </label>
                <select
                  onChange={(e) => handleChange2(e, "jobtitle")}
                  value={formData.jobtitle}
                  className="bg-white p-3 border border-[#212121] rounded focus:outline-none focus:ring-[#212121] focus:ring-1 w-full taextblack"
                >
                  <option value="">Select One</option>
                  <option value="Executive">Executive</option>
                  <option value="Vice President">Vice President</option>
                  <option value="Director">Director</option>
                  <option value="Senior Manager">Senior Manager</option>
                  <option value="Manager">Manager</option>
                  <option value="Staff">Staff</option>
                  <option value="President/Superintendent">President/Superintendent</option>
                  <option value="Senior Administrator">Senior Administrator</option>
                  <option value="Faculty/Staff/Educator">Faculty/Staff/Educator</option>
                  <option value="Student">Student</option>
                  <option value="Other">Other</option>
                </select>
                {errors.jobtitle && touched.jobtitle && (
                  <p className="pt-2 text-red-600 text-xs invalid-feedback">{errors.jobtitle}</p>
                )}
              </div>

              <div className="md:col-span-2">
                <label className="mb-1 font-medium taextblack before:text-[#F14678] text-base before:content-['*']">
                  Message (If Any)
                </label>
                <textarea
                  rows="4"
                  className="p-3 border border-[#212121] rounded focus:outline-none focus:ring-[#212121] focus:ring-1 w-full taextblack"
                  name="message"
                  placeholder="Message (If Any)"
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && touched.message && (
                  <p className="pt-2 text-red-600 text-xs invalid-feedback">{errors.message}</p>
                )}
              </div>

              <div className="w-full md:col-span-2">
                <Button type="submit" disabled={isSubmitting} text="Submit" className="w-full" />
              </div>

              <div className="md:col-span-2">
                {successMessage && <p className="mb-5 font-semibold text-green-600 text-xl">{successMessage}</p>}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>


  );
};

export default ContactForm;
